// 261023 E3-P3h2 (H6 / K1 / K2) — «? Hướng dẫn» của bàn làm việc Chuyển thể: 10 mục theo thứ tự mảng `TOUR` của mockup Rev 2.2 (Sổ duyệt = mục 3); 3k-a (mockup Rev 3) sửa lời + đích khoanh cho khớp bố cục gọn, GIỮ 10 mục; 3k-c (User 26/10) trả cột bước bên trái + danh sách tập trong cột + dải hiện thẳng ≤ 3 mục.
// THUẦN, không antd/react. Copy viết cho biên tập viên và NÓI ĐÚNG MÃ ĐANG CHẠY (K1): không dạy từ-vựng-tự-nhận, không «tab có số đếm», không «hết 2 vòng thì dừng».
// Trạng thái ở query `tour=n` (mở thẳng được). Mỗi mục có «điều hướng trước» (`tourNavigate`) và câu «vùng này hiện khi…» nếu màn thật chưa có vùng đó.
import type { WorkbenchStageKey } from '../../../types/adaptationWorkbench';
import { enterReviewParams, goToStageParams } from './reviewBookView';

export type TourTarget = 'nav' | 'band' | 'ledger' | 'desc' | 'notrun' | 'vocab' | 'eplist' | 'tech' | 'more' | 'assist';
export interface TourStep {
  n: number;
  /** Giá trị `data-tour` của vùng khoanh. */
  target: TourTarget;
  title: string;
  bullets: [string, string];
  /** Nội dung «Xem chi tiết» (gập). */
  detail?: string;
  /** Khi vùng chưa có trên màn thật: nói vùng đó xuất hiện khi nào (không lỗi). */
  missing: string;
}

export const TOUR_STEPS: TourStep[] = [
  {
    n: 1, target: 'nav', title: 'Cột bước bên trái: năm bước, một đường thẳng',
    bullets: ['Mỗi hàng là một bước, số x/y là việc XONG THẬT. Bước cần bạn tự nổi lên với viền cam và nhãn “cần bạn”; bước máy làm xong thì lùi mờ, có dấu ✓.', 'Hàng “Sổ duyệt” ở trên cùng gom việc của cả truyện; ở bước ⑤ có thêm “N gợi ý” (việc không chặn). Danh sách tập của ⑤ nằm ngay dưới cột này.'],
    detail: 'Chấm cam = còn việc dở nhưng không chặn; chấm đỏ = có việc chặn. Truyện chạy theo chuỗi “Truyện mới” thì bước chưa chạy ghi “chưa chạy · Chặng 1” hoặc “Chặng 2”. Bước ③ chưa có số x/y vì danh sách từ chỉ tải khi bạn mở bước đó. Bước chưa tới vẫn bấm vào xem được.',
    missing: 'Cột bước hiện khi bàn làm việc đã tải xong.',
  },
  {
    n: 2, target: 'band', title: 'Máy tự chạy ba chặng, dải hiện đủ nhưng gọn',
    bullets: ['Dải trên cùng nói một câu máy đang làm gì và có đúng MỘT nút đỏ khi cần bạn (“Bắt đầu”, “Duyệt & chạy tiếp”, “Duyệt & đẩy N tập”). Nút phụ hay dùng (“Mở sổ duyệt”, “Dừng chuỗi”…) nằm ngay cạnh, màu thường.', 'Dưới câu chỉ hiện thẳng tối đa 2 dòng, và chỉ là lý do chặn hoặc lưu ý (lý do chặn luôn đứng đầu, không bị cắt). Thông tin còn lại gom vào “và n mục khác” — bấm để mở tại chỗ. “⋯” chỉ còn việc hiếm dùng (“Ẩn dải này”, “Bắt đầu với cài đặt khác…”).'],
    detail: 'Chặng 1: quét nguồn, dựng khung xương và tổng quan. Chặng 2: bản địa hoá, chia tập, viết mọi tập. Chặng 3: đẩy sang Chapters. Mỗi bước máy tự chấm và sửa tối đa 2 vòng; còn lỗi thì máy vẫn chạy tiếp và ghi vào Sổ duyệt. Máy chỉ dừng hỏi bạn khi lỗi chặn thật hoặc khi chạm giới hạn AI của truyện. Bấm “Bắt đầu” là máy chạy luôn, không hỏi thêm: thể loại để trống, số tập để máy đề xuất, 2 phút mỗi tập, giữ cốt lõi, Tây hoá. Mục “Kiểm trước khi bấm” (✓ ổn · ! lưu ý, không chặn) nằm trong “và n mục khác”; mục “!” hiện thẳng.',
    missing: 'Dải này hiện khi truyện chạy theo chuỗi “Truyện mới” (từ nút “Bắt đầu” tới khi đẩy xong). Truyện làm tay từng bước thì không có dải.',
  },
  {
    n: 3, target: 'ledger', title: 'Sổ duyệt: cả truyện trên một màn',
    bullets: ['Mở từ hàng “Sổ duyệt” ở cột bước (hoặc nút “Mở sổ duyệt” ở dải). Mỗi tập một hàng: giám khảo AI chấm gì, lỗi, tên gốc rò, tình tiết chưa lên phim, đã đẩy chưa. Bấm một ô để mở đúng chỗ.', 'Tab “Máy đã tự sửa” cho xem trước/sau và hoàn tác; “Còn cần bạn” là chỗ máy dừng, “Gợi ý” là việc không chặn.'],
    detail: 'Tập đạt thì tick nhiều tập rồi bấm “Duyệt & đẩy N tập” ở thanh đáy; khi đã tick thì nút đỏ nằm ở thanh đáy, nút ở dải chuyển thành nút phụ. Hàng đầu gom việc dở ở bước 1–4.',
    missing: 'Sổ duyệt hiện khi máy viết xong tập đầu tiên (trước đó chưa có gì để duyệt).',
  },
  {
    n: 4, target: 'desc', title: 'Mỗi bước có một dòng mô tả',
    bullets: ['Dòng nhỏ dưới tên bước cho biết bước này làm gì và bạn cần làm gì.', 'Nút chính của bước nằm ở dải phía trên (khi truyện chạy theo chuỗi) hoặc ở thanh trên của bước.'],
    detail: 'Khi dải đang giữ việc duyệt, đầu bước chỉ nhắc “Duyệt bằng nút đỏ ở dải phía trên” để không có hai nút cùng tên.',
    missing: 'Dòng mô tả hiện ở đầu mỗi bước.',
  },
  {
    n: 5, target: 'notrun', title: 'Bước chưa chạy thì có hộp giải thích',
    bullets: ['Hộp này nói máy sẽ tự chạy bước này ở Chặng 1 hay Chặng 2. Bước đang chạy hiện vòng quay và tên việc máy đang làm.', 'Muốn tự làm tay: mở “Tự xử lý bước này” (nút nào đang khoá thì hộp nói vì sao).'],
    detail: 'Chỉ truyện chạy theo chuỗi “Truyện mới” mới có hộp này; bước làm tay vẫn hiện nguyên màn như cũ.',
    missing: 'Hộp này hiện ở bước máy chưa chạy tới, trong truyện chạy theo chuỗi “Truyện mới”. Truyện này không có bước nào như vậy lúc này.',
  },
  {
    n: 6, target: 'vocab', title: 'Từ vựng: xem và chấp nhận',
    bullets: ['Bảng Từ vựng chia ba nhóm: “Cần bạn” (hiện sẵn, kèm lý do), “Máy tự nhận” (chỉ khi suy đúng từ tên nhân vật bạn đã chốt, nên thường ít) và “Đã chấp nhận”. Nút Chấp nhận ở từng từ, hoặc “Chấp nhận hết (n)” cho mọi từ còn chờ.', 'Từ “Cần bạn” không chặn việc viết hay đẩy; bạn có thể để đó.'],
    detail: 'Sửa từ ở cột “Trong phim”; xoá từ không đổi kịch bản đã viết.',
    missing: 'Bảng từ vựng hiện sau khi khung xương đã duyệt và máy đã chạy bước Bản địa hoá.',
  },
  {
    n: 7, target: 'eplist', title: 'Danh sách tập ở cột trái, vào ⑤ là thấy ngay một tập',
    bullets: ['Mỗi tập một dòng có chip: Đạt · Đang sửa · Chờ · Máy chưa sửa được · Cần xem · Cần kiểm lại · Đã đẩy. Vào bước ⑤ là máy mở sẵn tập đầu tiên đang có lỗi (không có lỗi thì tập 1); bấm tập khác ở cột để đổi.', 'Ô vuông cạnh tập để chọn một dải liền rồi bấm nút viết ở cuối danh sách; giữ Shift để chọn cả đoạn. Hàng lọc ở trên lọc theo việc.'],
    detail: 'Chỉ chọn được một dải liền để viết, vì máy viết tuần tự. Dữ liệu đổi (máy sửa xong một tập) không tự chuyển bạn sang tập khác, để không mất phần bạn đang sửa dở.',
    missing: 'Danh sách tập hiện ở bước ⑤ sau khi đã chia tập.',
  },
  {
    n: 8, target: 'tech', title: 'Kịch bản trước, phần kỹ thuật gập sau “Chi tiết kỹ thuật ▸”',
    bullets: ['Mở tập là thấy kịch bản ngay. Tập có lỗi thì câu lý do và nút hành động hiện sẵn; thẻ “Máy đã tự sửa” (trước/sau, Hoàn tác) hiện ngay dưới tên tập khi bản sửa của máy đã được nhận. Biên lai giám khảo chỉ hiện một dòng tóm tắt, bấm “Xem chi tiết” mới mở.', 'Chỉ phần thật sự kỹ thuật (mô hình, số vòng, truy vết bước ③, biên lai, người phụ không tên, “Chấm lại bằng AI”) nằm sau “Chi tiết kỹ thuật ▸” ở cuối trang tập; không có gì bị xoá.'],
    detail: 'Thanh “Nhảy tới cảnh” cho bạn đi thẳng tới một cảnh trong tập. Trang tập chỉ còn ba nút: Sửa · ✦ Trợ lý · ⋯.',
    missing: 'Phần này hiện khi bạn mở một tập đã viết ở bước ⑤.',
  },
  {
    n: 9, target: 'more', title: '“⋯” gom việc phụ của bước',
    bullets: ['Ở bước ⑤: “Viết N tập chưa viết”, “Đẩy sang Chapters…”, “AI đọc cả mùa…” (việc của cả danh sách) và, khi đang mở một tập, “Viết lại tập”, “Phiên bản”, “Chấm lại bằng AI”, “Đẩy riêng tập này sang Chapters”, “Người phụ không tên”; cuối cùng là “Hướng dẫn”.', 'Đẩy cả mùa là nút đỏ “Duyệt & đẩy N tập” ở dải trên cùng (hoặc nút “Đẩy N tập” ở cuối cột trái khi truyện không chạy chuỗi); “Đẩy riêng” chỉ đẩy đúng tập đang mở và vẫn qua các cổng kiểm của máy chủ.'],
    detail: 'Vẫn hỏi hộp thoại khi còn tên gốc rò. Ở Sổ duyệt, tick tập đạt thì thanh “Duyệt & đẩy N tập” hiện ở đáy.',
    missing: 'Nút “⋯” có ở thanh trên của mọi bước.',
  },
  {
    n: 10, target: 'assist', title: 'Trợ lý AI mở bằng nút “✦ Trợ lý”',
    bullets: ['Trợ lý đóng sẵn; bấm “✦ Trợ lý” ở thanh trên để mở thành cột bên phải khi cần hỏi hoặc nhờ sửa.', 'Mọi gợi ý chỉ chạy khi bạn bấm Áp.'],
    detail: 'Trợ lý cũng tự mở khi bạn bấm “Nhờ Trợ lý sửa lỗi” hoặc “Phương án (tốn AI)”.',
    missing: 'Nút “✦ Trợ lý” luôn có ở thanh trên.',
  },
];

export const TOUR_LENGTH = TOUR_STEPS.length;

/** `tour=n` hợp lệ = số nguyên 1–10; mọi giá trị khác ⇒ null (không có tour). */
export const parseTour = (v: string | null | undefined): number | null => {
  if (typeof v !== 'string' || !/^\d+$/.test(v)) return null;
  const n = Number(v);
  return n >= 1 && n <= TOUR_LENGTH ? n : null;
};
export const tourStep = (n: number | null | undefined): TourStep | null => (n && n >= 1 && n <= TOUR_LENGTH ? TOUR_STEPS[n - 1] : null);

export const tourParams = (prev: URLSearchParams, n: number | null): URLSearchParams => {
  const p = new URLSearchParams(prev);
  if (n === null) p.delete('tour'); else p.set('tour', String(n));
  return p;
};

/** Những gì tour cần biết về truyện để chọn màn cho từng mục. */
export interface TourWorld {
  /** Sổ duyệt đã có (≥ 1 tập viết). */
  hasReview: boolean;
  /** Bước ②–⑤ đầu tiên mà chuỗi chưa chạy tới / đang chạy (nơi có hộp V12); null nếu không có. */
  firstNotRunStage: WorkbenchStageKey | null;
  firstWrittenEp: number | null;
}

/** Đưa màn tới chỗ mục `step` khoanh vùng; luôn giữ `tour=n`. */
export const tourNavigate = (prev: URLSearchParams, step: TourStep, w: TourWorld): URLSearchParams => {
  let p = new URLSearchParams(prev);
  const toStage = (s: WorkbenchStageKey) => { p = goToStageParams(p, s); };
  switch (step.target) {
    case 'ledger': if (w.hasReview) p = enterReviewParams(p); break;
    case 'desc': toStage('skeleton'); break;
    case 'notrun': if (w.firstNotRunStage) toStage(w.firstNotRunStage); break;
    case 'vocab': toStage('localize'); break;
    case 'eplist': toStage('script'); break;   // 3k-c: danh sách tập nằm ở cột trái, ⑤ luôn mở một tập ⇒ KHÔNG xoá `ep` (xoá sẽ đánh nhau với việc tự mở tập mặc định)
    case 'more': toStage('script'); break;
    case 'tech':
      toStage('script');
      if (!p.get('ep') && w.firstWrittenEp !== null) p.set('ep', String(w.firstWrittenEp));
      break;
    default: break;
  }
  p.set('tour', String(step.n));
  return p;
};

export interface KeyTarget { tagName?: string; isContentEditable?: boolean }
/** R4/F5 — phím của Hướng dẫn: Esc luôn đóng; ←/→ đổi mục NHƯNG bỏ qua khi tiêu điểm ở ô nhập (input / textarea / select / contenteditable) để không cướp phím của người đang gõ. */
export const tourKeyAction = (key: string, target: KeyTarget | null | undefined): 'exit' | 'next' | 'prev' | null => {
  if (key === 'Escape') return 'exit';
  if (key !== 'ArrowRight' && key !== 'ArrowLeft') return null;
  const tag = (target?.tagName ?? '').toUpperCase();
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target?.isContentEditable) return null;
  return key === 'ArrowRight' ? 'next' : 'prev';
};
